import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList, useGoBack, useProfilesTabNavigation } from '../../../../../utils/appNavigationNames';
import { useClientInvoiceItemsState } from '../../../../shared/ClientInvoiceItems';
import AddInvoiceItemContent from './AddInvoiceItemContent';
import EditInvoiceItemContent from './EditInvoiceItemContent';
import InvoiceItemsListContent from './InvoiceItemsListContent';
import { RequiredClientBillingInfoGate } from '../../../../shared/EditClientBillingInfo';

export type ClientInvoiceItemsScreenOwnProps = {};

export type ClientInvoiceItemsScreenProps = ClientInvoiceItemsScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'client-invoice-items'>;
};

const ClientInvoiceItemsScreen: React.FC<ClientInvoiceItemsScreenProps> = ({ route }) => {
    const goBack = useGoBack();
    const { clientRecordId } = route.params;
    const { navigate } = useProfilesTabNavigation();

    const {
        state,
        onAddInvoiceLineItem,
        onEditInvoiceLineItem,
        onCancel,
        onEditComplete,
        onAddComplete,
        onInvoiceSent,
    } = useClientInvoiceItemsState({
        onComplete: goBack,
    });

    if (!clientRecordId) {
        return null;
    }

    const renderContent = () => {
        if (state.type === 'list') {
            return (
                <InvoiceItemsListContent
                    clientRecordId={clientRecordId}
                    onAddInvoiceLineItem={onAddInvoiceLineItem}
                    onEditInvoiceLineItem={onEditInvoiceLineItem}
                    onInvoiceSent={onInvoiceSent}
                    onEditBillingDetails={() => navigate('edit-client-billing-info', { clientRecordId })}
                />
            );
        } else if (state.type === 'add') {
            return (
                <AddInvoiceItemContent
                    clientRecordId={clientRecordId}
                    onCancel={onCancel}
                    onCreateInvoiceItem={onAddComplete}
                />
            );
        } else {
            return (
                <EditInvoiceItemContent
                    clientRecordId={clientRecordId}
                    invoiceItemId={state.invoiceItemId}
                    onCancel={onCancel}
                    onUpdateInvoiceItem={onEditComplete}
                />
            );
        }
    };

    return (
        <RequiredClientBillingInfoGate clientRecordId={clientRecordId}>{renderContent}</RequiredClientBillingInfoGate>
    );
};

export default React.memo(ClientInvoiceItemsScreen);
